import { useTLang } from 'intl/intl';

export function useSOClientDetailLang() {
  return {
    sectionTitle: useTLang({ id: 'scheduleOrder.detail.clientSectionTitle' }),
  };
}
